import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
  {
    apiUrl: `/access-point/report`,

    async getLastAccessReport() {
      return Vue.http({
        url: this.url("/last-access"),
        method: "GET",
        responseType: "blob",
      });
    },
  },
  base
);
